// extracted by mini-css-extract-plugin
export default {"wrapper":"Portfolio_wrapper__DqVMe","container":"Portfolio_container__G3yKa","projects":"Portfolio_projects__EULx7"};